<div class="row-chips"
     [ngClass]="{'show-chips': chipsState | async}">
    <ng-content select="div.row-details"></ng-content>
    <aa-chips-tags-container [tags]="tags | async"
                             *ngIf="(chipsState | async) && (tags !== null && tags !== undefined)"
                             (attachTagEvent)="onAttachTagEvent($event)"
                             (detachTagEvent)="onDetachTagEvent($event)"
                             [isFiltrable]="isFiltrable">
    </aa-chips-tags-container>
</div>
